import BareBonesLayout from "./BareBonesLayout";
import StandardAppLayout from "./StandardAppLayout";
import TreeTargetLayout from "./TreeTargetLayout";
import RouterViewLayout from "./RouterViewLayout";

export default {
	BareBonesLayout,
	StandardAppLayout,
	TreeTargetLayout,
	RouterViewLayout,
};
